module.exports = __webpack_public_path__ + "static/media/sfx_amb_fades_03.d35678d7.mp3";